import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'help-image',
  templateUrl: './help-image.component.html',
  styleUrls: ['../help.content.css']
})
export class HelpImageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
